import _ from 'lodash';
import { goto, preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { getFormSyncErrors, isInvalid } from 'redux-form';
import * as api from 'app/api/account-settings-api';
import { fetchMachinesForUser } from 'app/common/api/common-api';
import UserInvite from 'app/components/settings/user-invite';
import * as machines from 'app/selectors/machines';
import { subscriptions } from 'app/selectors/subscriptions';
import { contentfulModels } from '@glowforge/ui-common';

const { getStringsForPage, getMarkdownStringsForPage } = contentfulModels;

const REDIRECT_DELAY = 500;

const mapStateToProps = state => ({
  machines: machines.getMachineList(state),
  managedMachines: machines.getManagedMachineList(state),
  initialValues: machines.getInitialMachineForInvite(state),
  machineListError: _.get(getFormSyncErrors('userInviteForm')(state), 'machines'),
  formInvalid: isInvalid('userInviteForm')(state),
  pageStrings: getStringsForPage(_.get(state, 'accountSettings.settingsPage.fields')),
  pageMarkdownStrings: getMarkdownStringsForPage(_.get(state, 'accountSettings.settingsPage.fields')),
  isLoading: _.get(state, 'common.machinesLoading') || !BROWSER,
  subscription: subscriptions.current(state),
  addedUsers: subscriptions.getAddedUsers(state),
});

const mapDispatchToProps = (dispatch, props) => ({
  onCancel: () => {
    if (props.location.query.returnUrl) {
      window.location.href = props.location.query.returnUrl;
    } else {
      dispatch(goto('/settings/users'));
    }
  },
  onSubmit: values =>
    new Promise((resolve) => {
      dispatch(api.sendInvites(values, () => {
        setTimeout(() => {
          if (props.location.query.returnUrl) {
            window.location.href = props.location.query.returnUrl;
          } else {
            dispatch(goto('/settings/users'));
          }
        }, REDIRECT_DELAY);
        resolve();
      }));
    }),
});

const UserInviteContainer = connect(mapStateToProps, mapDispatchToProps)(preload(
  ({ dispatch, getState }) => {
    const promises = [];
    // If we already have a list of machines for users show that list and
    // kick off async refresh calls
    if (!_.get(getState(), 'common.machinesLoading')) {
      promises.push(dispatch(fetchMachinesForUser()));
    }

    return Promise.all(promises);
  }, { })(UserInvite),
);

export default UserInviteContainer;



// WEBPACK FOOTER //
// ./app/containers/settings/invite.js